import history from '@AppRoutes/history';
import { paths } from '@AppRoutes/constants';
import { resetPasswordWithToken as authResetPasswordWithToken } from '@Services/Auth/AuthResetPassword';
import Catalyst from '@Services/Catalyst';

import {
  resetPasswordWithTokenDialogSetConfirmationPasswordReducerType,
  resetPasswordWithTokenDialogSetResponseStatusReducerType,
  resetPasswordWithTokenDialogSetNewPasswordReducerType,
  resetPasswordWithTokenDialogSetErrorDetailsReducerType,
  RESPONSE_STATUS,
} from './ResetPasswordWithTokenDialogConstants';

import {
  confirmationPassword as confirmationPasswordSelector,
  newPassword as newPasswordSelector,
} from './ResetPasswordWithTokenDialogSelectors';

export const openResetPasswordWithTokenDialog = (props) => () => {
  const token = props?.token;
  const search = token ? `?token=${encodeURIComponent(token)}` : '';
  history.push({
    pathname: paths.RESET_PASSWORD,
    search,
  });
};

export const closeResetPasswordWithTokenDialog = () => () => history.push(paths.LOGIN);

export function trackAdobeAnalyticsError(errors, prefix) {
  if (errors && errors.length) {
    errors.forEach((error) =>
      Catalyst.trackError(
        {
          message: error,
          component: 'Reset password',
        },
        prefix
      )
    );
  }
}

export function setResponseStatus(responseStatus) {
  return {
    type: resetPasswordWithTokenDialogSetResponseStatusReducerType,
    payload: { responseStatus },
  };
}

export function setNewPassword(newPassword) {
  return {
    type: resetPasswordWithTokenDialogSetNewPasswordReducerType,
    payload: { newPassword },
  };
}

export function setConfirmationPassword(confirmationPassword) {
  return {
    type: resetPasswordWithTokenDialogSetConfirmationPasswordReducerType,
    payload: { confirmationPassword },
  };
}

export function setErrorDetails(errorDetails) {
  return {
    type: resetPasswordWithTokenDialogSetErrorDetailsReducerType,
    payload: { errorDetails },
  };
}

export const submit = (token) => async (dispatch, getState) => {
  const newPassword = newPasswordSelector(getState());
  const confirmationPassword = confirmationPasswordSelector(getState());

  if (!(newPassword.value && confirmationPassword.value) || !(newPassword.isValid && confirmationPassword.isValid)) {
    return;
  }

  dispatch(setResponseStatus(RESPONSE_STATUS.LOADING));

  await authResetPasswordWithToken(token, newPassword.value)
    .then(() => {
      dispatch(setResponseStatus(RESPONSE_STATUS.SUCCESS));
      dispatch(setErrorDetails(null));
    })
    .catch((error) => {
      Logger.error(error);
      const errorMessage = error?.message || error?.data?.message || 'An error occurred while resetting your password';
      dispatch(setErrorDetails(errorMessage));
      dispatch(setResponseStatus(RESPONSE_STATUS.ERROR));
    });
};
